import { isEmpty } from "lodash";
import { FC, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrivateLoader } from "src/components/templates";
import { Button, Grid, Typography } from "src/components/UI";
import Icon from "src/components/UI/CustomUI/atoms/Icon";
import { itemsActions } from "src/ducks/actions";
import { getRemovedItemsHistory } from "src/ducks/history/selectors";
import { getEstimate } from "src/ducks/selectors";
import { RemovedItem } from "src/ducks/types";
import { WorkOrdersContext } from "../../../context";
import RemovedItemDetail from "./RemovedItemDetail";
import styles from './styles.module.scss';

const RecoverRemovedItems: FC = () => {
    const { dispatch: dispatchContext } = useContext(WorkOrdersContext)
    const dispatch = useDispatch()
    const estimate = useSelector(getEstimate())
    const removedItems = useSelector(getRemovedItemsHistory)
    const [loading, setLoading] = useState(false)
    const [itemSelected, setItemSelected] = useState<RemovedItem>()

    const handleClose = () => {
        dispatchContext({ type: 'SET_MODAL_OPEN', payload: false })
    }

    const handleRecoverItem = () => {
        setLoading(true)
        if (itemSelected) {
            dispatch(itemsActions.recoverItem({ item: itemSelected?.data, id: estimate?.id }, (succ) => {
                succ && dispatch(itemsActions.fetchItemsByCategory({
                    params: { jobId: estimate?.id, }
                }, (_succ) => {
                    handleClose()
                    setLoading(false)
                }))
            }))
        }
    }

    return (
        <PrivateLoader loading={loading}>
            <Typography marginBottom="1.5rem">Select a deleted item to re-add</Typography>
            <Grid container className={styles.RecoverRemovedItems} spacing={2}>
                <Grid item xs={12}>
                    <Grid border="2px solid var(--border-color)" width="100%" borderRadius={4} className={styles.RecoverRemovedItems__container}>
                        {removedItems.length > 0 && removedItems.map((item, index) => <RemovedItemDetail key={index} item={item} setItemSelected={setItemSelected} itemSelected={itemSelected} />)}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item container justifyContent="flex-end" margin="1rem 0" gap={1}>
                <Button
                    variant="containedLight"
                    onClick={handleClose}
                >
                    <Typography variant="h5">
                        Cancel
                    </Typography>
                </Button>
                <Button
                    variant="contained"
                    endIcon={<Icon name="Undo" width=".8rem" />}
                    onClick={handleRecoverItem}
                    disabled={isEmpty(itemSelected)}
                >
                    <Typography variant="h5">
                        Recover Item
                    </Typography>
                </Button>
            </Grid>
        </PrivateLoader>
    )
}

export default RecoverRemovedItems